var map = {
	"./1020.png": 96539,
	"./404-image.png": 20699,
	"./404-page.jpg": 88625,
	"./Amari.png": 78145,
	"./Digital-Playground-Blog.jpg": 3893,
	"./Digital_Playground_Blog_Image.jpg": 5948,
	"./Disney100_social_post_1.jpg": 95394,
	"./Disney100_social_post_2.jpg": 4640,
	"./Disney100_social_post_3.jpg": 28474,
	"./Ellipse79.png": 14128,
	"./Lingokids-logo.png": 63388,
	"./MpFilter.png": 27959,
	"./MpFlower.png": 24599,
	"./MpFooter.png": 19578,
	"./MpPlay.png": 41458,
	"./MpRainbow.png": 98969,
	"./Mpstar.png": 50553,
	"./Polygon2.png": 53984,
	"./SpBlack.png": 14470,
	"./Star31.png": 60142,
	"./Star35.png": 1302,
	"./StroyShild-Little_Mermaid-f.png": 27151,
	"./WorldMap.png": 73827,
	"./World_map_dotted.jpg": 60153,
	"./about-img1.png": 55865,
	"./about-img2.png": 40486,
	"./about-img3.png": 86321,
	"./about-img4.png": 88824,
	"./about-img5.png": 98427,
	"./about-img6.png": 47475,
	"./about.png": 56440,
	"./activeIcon.png": 84330,
	"./aduntitled.png": 96874,
	"./android-1.png": 42807,
	"./android-10.png": 26918,
	"./android-2.png": 43506,
	"./android-3.png": 38798,
	"./android-4.png": 88357,
	"./android-5.png": 46643,
	"./android-6.png": 35598,
	"./android-7.png": 61992,
	"./android-8.png": 64721,
	"./android-9.png": 60245,
	"./android-logo.png": 22732,
	"./app-four.png": 97239,
	"./app-img2.jpg": 21580,
	"./app-one.png": 40266,
	"./app-store.jpg": 5497,
	"./app-three.png": 62084,
	"./app-two.png": 60547,
	"./audio-img.jpg": 50685,
	"./author1.png": 42674,
	"./back-button.png": 44819,
	"./banner-inner-page.jpg": 79717,
	"./banners-pinna-2.jpeg": 44786,
	"./best-inventions.png": 24899,
	"./bg2.png": 92960,
	"./bird-body.png": 28482,
	"./bird-wings.png": 92192,
	"./blog-4-bottom-1-image.jpeg": 98327,
	"./blog-4-bottom-2-image.jpeg": 56754,
	"./blog-4-intro-image.jpg": 9943,
	"./blog-4-top-image.jpeg": 5748,
	"./book.png": 64004,
	"./btm-serial.jpg": 44473,
	"./category.png": 83315,
	"./category1.png": 13246,
	"./category2.png": 22307,
	"./category3.png": 83788,
	"./category4.png": 2913,
	"./ces-awards.png": 35082,
	"./check-mail.png": 13258,
	"./cleaned-img.jpg": 10093,
	"./coming-soon.png": 83773,
	"./contact-us.png": 62991,
	"./cookie.png": 37651,
	"./direct-download.png": 94158,
	"./disney-collections.png": 51214,
	"./disney-head.png": 44120,
	"./disney-img.png": 10716,
	"./disney-storyphones-image.jpg": 73197,
	"./disney-white.png": 36052,
	"./disney.png": 52593,
	"./disneyblue/1.png": 92117,
	"./disneyblue/2.png": 60218,
	"./disneyblue/3.png": 14231,
	"./disneyblue/4.png": 84512,
	"./disneyblue/5.png": 33516,
	"./disneyblue/6.png": 54934,
	"./disneyblue/7.png": 82284,
	"./disneypink/1.png": 17069,
	"./disneypink/2.png": 22633,
	"./disneypink/3.png": 77501,
	"./disneypink/4.png": 90985,
	"./disneypink/5.png": 77817,
	"./disneypink/6.png": 99810,
	"./disneypink/7.png": 68897,
	"./download-img.png": 27350,
	"./download.png": 62177,
	"./empty-cart.png": 3656,
	"./faq.png": 20573,
	"./flag-english.jpg": 84000,
	"./flag-french.jpg": 39009,
	"./flag-german.jpg": 22169,
	"./flag-italian.jpg": 12570,
	"./flag-spanish.jpg": 20903,
	"./flag-us-new.jpg": 57659,
	"./flag-us.jpg": 34769,
	"./fly-bird-head.png": 28971,
	"./fly-birds.png": 94951,
	"./global.png": 20007,
	"./google-play.jpg": 41488,
	"./grey/1.png": 76177,
	"./grey/2.png": 62062,
	"./grey/3.png": 79378,
	"./grey/4.png": 23954,
	"./grey/5.png": 36491,
	"./grey/6.png": 61787,
	"./greyBundle.png": 13058,
	"./headphones-shields-home-large.png": 73364,
	"./heart.png": 46382,
	"./home-footer-kids-large.png": 17430,
	"./hong-kong.jpg": 3091,
	"./icon-img1.png": 66615,
	"./icon-img2.png": 82628,
	"./icon-img3.png": 67786,
	"./icon-img4.png": 37427,
	"./icon-record.png": 87315,
	"./icons8-back-arrow-64.png": 95748,
	"./image.png": 31169,
	"./image1.jpg": 90246,
	"./image2.jpg": 4768,
	"./image3.jpg": 45646,
	"./image5.png": 86361,
	"./intro-bg.png": 41913,
	"./intro-bg2.png": 39824,
	"./inventions_award.png": 39957,
	"./ios-1.png": 11406,
	"./ios-2.png": 48249,
	"./ios-3.png": 60814,
	"./ios-4.png": 36256,
	"./ios-5.png": 94626,
	"./ios-6.png": 65779,
	"./ios-7.png": 23180,
	"./ios-8.png": 76521,
	"./ios-9.png": 53515,
	"./ios-logo.png": 26092,
	"./lastfallen.png": 81042,
	"./leaf_left.png": 35780,
	"./leaf_right.png": 34669,
	"./left-wing.png": 26983,
	"./left-wing1.png": 32993,
	"./left-wing2.png": 95409,
	"./lingokids-StoryPhones-1.jpg": 46211,
	"./lingokids-StoryPhones-2.jpg": 8048,
	"./lingokids-StoryPhones.png": 12098,
	"./lionmars.png": 62711,
	"./loader.gif": 31298,
	"./loading.gif": 89163,
	"./logo-black.png": 4080,
	"./logo.png": 74427,
	"./logo.svg": 82835,
	"./magical-btm-left-bg.png": 52083,
	"./magical-btm-right-bg.png": 46859,
	"./magical-top-left-bg.png": 88228,
	"./magical-top-right-bg.png": 24099,
	"./marketPlaceSignUp.png": 67329,
	"./marketplace-banner.png": 18293,
	"./marketplace-login.png": 85955,
	"./marketplace/Polygon.svg": 11871,
	"./marketplace/amari.png": 74561,
	"./marketplace/amy.png": 52397,
	"./marketplace/artwork.png": 546,
	"./marketplace/background.png": 91356,
	"./marketplace/bedtimestory.png": 31032,
	"./marketplace/bettylem.png": 70270,
	"./marketplace/blue-filter.svg": 88577,
	"./marketplace/btn-arrow.svg": 8098,
	"./marketplace/cecerids.png": 70952,
	"./marketplace/chapter.svg": 70785,
	"./marketplace/david.png": 74506,
	"./marketplace/dragon.png": 82847,
	"./marketplace/dropdown.svg": 66137,
	"./marketplace/emailconfrom.png": 55954,
	"./marketplace/john.png": 341,
	"./marketplace/kidssleep.png": 94920,
	"./marketplace/lastfallenmoon.png": 6589,
	"./marketplace/left-arrow.svg": 86139,
	"./marketplace/leftarrow.svg": 13150,
	"./marketplace/like-btn.svg": 88028,
	"./marketplace/lionofmars.png": 6953,
	"./marketplace/logo.svg": 16619,
	"./marketplace/magicbk.png": 45229,
	"./marketplace/magicman.png": 15057,
	"./marketplace/mark.svg": 68739,
	"./marketplace/marketplace-banner.png": 55689,
	"./marketplace/masg.svg": 90775,
	"./marketplace/meditation.png": 59313,
	"./marketplace/play-btn.svg": 76544,
	"./marketplace/right-arrow.svg": 12350,
	"./marketplace/rightarrow.svg": 91863,
	"./marketplace/search.svg": 83991,
	"./marketplace/stella.png": 17213,
	"./marketplace/white-Star.svg": 42225,
	"./marketplace/yellow-Star.svg": 36027,
	"./meeting.png": 60329,
	"./mmuntitled.png": 92670,
	"./nature-sprite.png": 66563,
	"./new-logo.png": 42173,
	"./otter.png": 5457,
	"./parachut.png": 7807,
	"./pixar.png": 52586,
	"./play-button.png": 94947,
	"./play.png": 93484,
	"./playshield-home1.jpg": 83608,
	"./playshield-plus.png": 67659,
	"./playshield-white.png": 10636,
	"./playshield.png": 28964,
	"./product-banner.png": 96405,
	"./product-image.png": 95644,
	"./product-rating.jpg": 76794,
	"./profile-pic.jpg": 58342,
	"./puffin.png": 41149,
	"./quotation-mark-btm.png": 70371,
	"./quotation-mark-top.png": 19431,
	"./quotes1.png": 47476,
	"./quotes2.png": 98857,
	"./right-wing.png": 24886,
	"./shape1.png": 63334,
	"./shape2.png": 40496,
	"./signup.png": 93734,
	"./stella.png": 241,
	"./story-img1.png": 299,
	"./story-img10.png": 62418,
	"./story-img11.png": 71728,
	"./story-img2.png": 20141,
	"./story-img3.png": 76604,
	"./story-img4.png": 1282,
	"./story-img5.png": 73225,
	"./story-img6.png": 69258,
	"./story-img7.png": 57765,
	"./story-img8.png": 27176,
	"./story-img9.png": 79881,
	"./story-popup.png": 13079,
	"./story-video.png": 26903,
	"./storyphones-headset.png": 29325,
	"./storyphones-image.jpg": 24727,
	"./storytelling-2.jpg": 33032,
	"./storytelling-3.jpg": 668,
	"./storytelling.jpg": 97423,
	"./stroyshild-frozen-f.png": 3219,
	"./success-payment.jpg": 85829,
	"./top-serial.jpg": 2201,
	"./urLeft.png": 14760,
	"./urNext.png": 54895,
	"./verification-bg.jpg": 17442,
	"./video-btn.svg": 34134,
	"./warranty-contact-us.jpg": 6936,
	"./warranty-reg.jpg": 83265,
	"./white/1.png": 67426,
	"./white/2.png": 28943,
	"./white/3.png": 46918,
	"./white/4.png": 65299,
	"./white/5.png": 39080,
	"./white/6.png": 91151,
	"./whiteBundle.png": 58241,
	"./zenshield-home.jpg": 87080,
	"./zenshield-white.png": 86143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;